import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let id = 0;
function createData(name, calories, fat, carbs, protein) {
    id += 1;
    return { id, name, calories, fat, carbs, protein };
}

const rows = [
    createData(19283 , 'MissingAddress', 'Closed', '14-SEP-18 16:00:02'),
    createData(19243 , 'MissingAddress', 'Closed', '14-SEP-18 12:05:02'),
    createData(19183 , 'MissingAmount', 'Escalated to L2', '14-SEP-18 11:20:02'),
    createData(19043 , 'ConflictOfInterest', 'Closed', '13-SEP-18 18:00:02'),
    createData(19001 , 'MissingInvAmount', 'Escalated to L2', '13-SEP-18 13:00:02'),
];

class MyLog extends Component{


    render() {
        const classes = this.props;
        return (
            <div className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>AlertID</TableCell>
                            <TableCell >Routine</TableCell>
                            <TableCell >Action</TableCell>
                            <TableCell >Timestamp</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell >{row.calories}</TableCell>
                                    <TableCell >{row.fat}</TableCell>
                                    <TableCell >{row.carbs}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

MyLog.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MyLog);


// WEBPACK FOOTER //
// ./src/components/Dashboard/MyLogTable.js